import { render, staticRenderFns } from "./NewUserLanding.vue?vue&type=template&id=fcd48d06&scoped=true&"
import script from "./NewUserLanding.vue?vue&type=script&lang=js&"
export * from "./NewUserLanding.vue?vue&type=script&lang=js&"
import style0 from "./NewUserLanding.vue?vue&type=style&index=0&id=fcd48d06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd48d06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fcd48d06')) {
      api.createRecord('fcd48d06', component.options)
    } else {
      api.reload('fcd48d06', component.options)
    }
    module.hot.accept("./NewUserLanding.vue?vue&type=template&id=fcd48d06&scoped=true&", function () {
      api.rerender('fcd48d06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/views/NewUserLanding.vue"
export default component.exports